import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { submitKeysOf } from '../components/workflow/useWorkflowPerms';
import WorkflowListShell from '../components/workflow/WorkflowListShell';
import { EngagementName, stripDupFyeLabel } from '../components/workflow/CoverageDisplay';
import WorkflowStatusBadge from '../components/workflow/WorkflowStatusBadge';
import ReviewerLapsedNote from '../components/workflow/ReviewerLapsedNote';
import { formatDateShort } from '../utils/dateFormat';

// QC35 Form Amendment — list page (docs/modules/workflow-qc35.md; separate from the
// Signed Financial Statements Amendment flow).
const WorkflowQc35a = () => {
  const { hasPermission } = useAuth();
  return (
    <WorkflowListShell
      title="QC35 Form Amendment"
      subtitle="Corrections to approved QC35 Forms."
      newTo="/workflow/qc35a/new"
      canCreate={submitKeysOf('qc35a').some(hasPermission)}
      apiPath="/api/workflow/qc35a"
      searchPlaceholder="Search request no / requester…"
      width="mid"
      rowTo={(r) => `/workflow/qc35a/${r.id}`}
      columns={[
        {
          key: 'requestNo',
          label: 'Request',
          sortKey: 'requestNo',
          className: 'whitespace-nowrap',
          render: (r) => (
            <Link
              to={`/workflow/qc35a/${r.id}`}
              onClick={(e) => e.stopPropagation()}
              className="text-blue-600 hover:text-blue-800 font-medium"
            >
              {r.requestNo}
            </Link>
          ),
        },
        { key: 'engagementLabel', label: 'Engagement', sortKey: 'engagementLabel', render: (r) => <EngagementName name={stripDupFyeLabel(r.engagementLabel)} serviceDescription={r.serviceDescription} /> },
        { key: 'status', label: 'Status', sortKey: 'status', render: (r) => (<><WorkflowStatusBadge status={r.status} /><ReviewerLapsedNote when={r.reviewerLapsed} /></>) },
        { key: 'requester', label: 'Requested By', className: 'text-slate-600', render: (r) => r.requesterEmail },
        { key: 'createdAt', label: 'Submitted', sortKey: 'createdAt', className: 'text-slate-600 whitespace-nowrap', render: (r) => formatDateShort(r.createdAt) },
      ]}
    />
  );
};

export default WorkflowQc35a;
